import React, {useState, useEffect, useContext} from 'react';
import {Context} from '../../../Helpers/Auth';

import {useHistory} from 'react-router-dom';
import i18n from '../../../i18n';
import {useTranslation} from 'react-i18next';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CloseIcon from '@mui/icons-material/Close';
import {getVIES} from '../../../pages/Despesas/requests';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SelectComponent from '../../Selects/SelectComponent';
import {ToastContainer} from 'react-toastify';
import Detalhes from './Detalhes';

import {v4 as uuidv4} from 'uuid';

import {
    getVaidacaoNifPais,
    getValidaNif,
    getContaCorrente,
    getContactosProspect,
    getFuncoesContactos,
    getInfoExtraProspects,
    getProspectId,
    postProspect,
    getPaises,
    getLinguas,
    getMoedas,
    getRepresentantes,
    getActividades,
    getOrigens,
    getCategorias,
    getProdutosVendidos,
    getContactoInteresses,
} from '../../../pages/requests';
import Spinner from '../../Spinner';
import Endereco from './Endereco';
import Contactos from './Contactos';
import ProdutosVendidos from './ProdutosVendidos';
import {Paragliding} from '@mui/icons-material';
import ParqueEquipamentos from './ParqueEquipamentos';
import ContaCorrente from './ContaCorrente';
import HistoricoVisitas from './HistoricoVisitas';
import {ValidacaoNif} from '../../../Helpers/validacoes';
import HistoricoOportunidades from './HistoricoOportunidades';
import HistoricoPropostas from './HistoricoPropostas';
import {getCortesias, getLead} from '../../Leads/api';
import ExitForm from '../../ExitFormModal';
import LoadingModal from '../../LoadingModal';

function ProspectsForm({
    setOpenTab,
    prospect,
    setShowForm,
    setEditarProspect,
    editarProspect,
    openTab,
    setGuardar,
    guardar,
    onChangeForm,
    setOnChangeForm,
    setNovaReuniaoVisita,
    novaReuniaoVisita,
    // produtos vendidos
    filtroReferencia,
    setFiltroReferencia,
    filtroDesc,
    setFiltroDesc,
    filtroQuantidade,
    setFiltroQuantidade,
    filtroPreco,
    setFiltroPreco,
    filtroNumEncomenda,
    setFiltroNumEncomenda,
    formattedDateEnc,
    setFormattedDateEnc,
    dataPdf,
    setDataPdf,
    filtroDtEncomenda,
    setFiltroDtEncomenda,
    filtroPrecoTotal,
    setFiltroPrecoTotal,
    // parque de equipamentos
    filtroNumEquipamento,
    setFiltroNumEquipamento,
    filtroNumSerie,
    setFiltroNumSerie,
    filtroArtigo,
    setFiltroArtigo,
    filtroMarca,
    setFiltroMarca,
    filtroNacionalInternacional,
    setFiltroNacionalInternacional,
    filtroTipo,
    setFiltroTipo,
    filtroModelo,
    setFiltroModelo,
    filtroVersao,
    setFiltroVersao,
    filtroEspecificacao,
    marcas,
    setMarcas,
    nacionaisInternacionais,
    setNacionaisInternacionais,
    tipos,
    setTipos,
    modelos,
    setModelos,
    versoes,
    setVersoes,
    setFiltroEspecificacao,
    filtroDescParque,
    setFiltroDescParque,
    // conta corrente
    filtroSociedade,
    setFiltroSociedade,
    filtroEstab,
    setFiltroEstab,
    filtroEndereco,
    setFiltroEndereco,
    filtroDtFatura,
    setFiltroDtFatura,
    filtroDtVencimento,
    setFiltroDtVencimento,
    filtroRep,
    setFiltroRep,
    filtroValor,
    setFiltroValor,
    filtroValorPendente,
    setFiltroValorPendente,
    filtroNumDoc,
    setFiltroNumDoc,
    filtroDivisa,
    setFiltroDivisa,
    representantes,
    setRepresentantes,
    estabelecimentos,
    setEstabelecimentos,
    divisas,
    setDivisas,
    //historico visitas
    filtroCodigo,
    setFiltroCodigo,
    filtroEstabHistorico,
    setFiltroEstabHistorico,
    filtroCategoria,
    setFiltroCategoria,
    filtroDtInicio,
    setFiltroDtInicio,
    filtroDtFim,
    setFiltroDtFim,
    filtroRepHistorico,
    setFiltroRepHistorico,
    //historico de oportunidades
    filtroNomeHistorico,
    setFiltroNomeHistorico,
    filtroEtapa,
    setFiltroEtapa,
    filtroRepHisOp,
    setFiltroRepHisOp,
    filtroEmpresa,
    setFiltroEmpresa,
    filtroDt,
    setFiltroDt,
    filtroValorHistorico,
    setFiltroValorHistorico,
    etapasHistoricoOp,
    setEtapasHistoricoOp,
    representantesHistoricoOp,
    setRepresentantesHistoricoOp,
    // historico proposta
    filtroId,
    setFiltroId,
    filtroTipoProposta,
    setFiltroTipoProposta,
    filtroDtProposta,
    setFiltroDtProposta,
    filtroCliente,
    setFiltroCliente,
    filtroEstado,
    setFiltroEstado,
    filtroLinhas,
    setFiltroLinhas,
    formattedDate,
    setFormattedDate,
    ids,
    setIds,
    tiposProposta,
    setTiposProposta,
    estados,
    setEstados,
    novoNegocio,
    setNovoNegocio,
}) {
    // First, checks if it isn't implemented yet.
    if (!String.prototype.format) {
        String.prototype.format = function () {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
    }

    const {t} = useTranslation();
    const history = useHistory();
    const {acessos, utilizador, userRepresentante} = useContext(Context);

    // DETALHES FORM
    const [pais, setPais] = useState(null);
    const [lingua, setLingua] = useState(null);
    const [divisa, setDivisa] = useState(null);
    const [nif, setNif] = useState('');
    const [onBlurNif, setOnBlurNif] = useState(false);
    const [razaoSocial, setRazaoSocial] = useState('');
    const [categoria, setCategoria] = useState(null);
    const [responsavel, setResponsavel] = useState(userRepresentante);
    const [origem, setOrigem] = useState(null);
    const [actividade, setActividade] = useState(null);

    const [familia1, setFamilia1] = useState(null);
    const [familia2, setFamilia2] = useState(null);
    const [familia3, setFamilia3] = useState(null);
    const [familia4, setFamilia4] = useState(null);
    const [familia5, setFamilia5] = useState(null);

    const [paises, setPaises] = useState([]);

    const [linguas, setLinguas] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);
    const [origens, setOrigens] = useState([]);
    const [moedas, setMoedas] = useState([]);
    const [actividades, setActividades] = useState([]);

    const [tamanhoNif, setTamanhoNif] = useState(11);

    //Validações
    const [validacaoRS, setValidacaoRS] = useState(false);
    const [validacaoNif, setValidacaoNif] = useState(false);
    const [validacaoCP, setValidacaoCP] = useState(false);
    const [validacaoOrigem, setValidacaoOrigem] = useState(false);
    const [validacaoTlm, setValidacaoTlm] = useState(false);
    const [validacaoEmail, setValidacaoEmail] = useState(false);
    const [validacaoApelido, setValidacaoApelido] = useState(false);
    const [validacaoNome, setValidacaoNome] = useState(false);
    const [validacaoCortesia, setValidacaoCortesia] = useState(false);
    const [validacaoFuncao, setValidacaoFuncao] = useState(false);
    const [validacaoPais, setValidacaoPais] = useState(false);
    const [validacaoLingua, setValidacaoLingua] = useState(false);
    const [validacaoDivisa, setValidacaoDivisa] = useState(false);
    const [validacaoCategoria, setValidacaoCategoria] = useState(false);
    const [validacaoRep, setValidacaoRep] = useState(false);
    const [validacaoCatContacto, setValidacaoCatContacto] = useState(false);
    const [validacaoActividade, setValidacaoActividade] = useState(false);

    const [optionsCortesia, setOptionsCortesia] = useState(null);

    const [showExitModal, setShowExitModal] = useState(false);

    const [erroMsg, setErroMsg] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [loadingM, setLoadingM] = useState(false);
    const ITEMS_PER_PAGE = 15;

    //Mensagens erro
    const [msgNif, setMsgNif] = useState('');
    // const [msgCP, setMsgCP] = useState("");
    const [msgTlm, setMsgTlm] = useState('');
    const [msgEmail, setMsgEmail] = useState('');

    const [totalRegistos, setTotalRegistos] = useState(0);

    useEffect(() => {
        debugger;
        if (history.location.state?.lead) {
            setOpenTab(1);
            setShowForm(true);
            setEditarProspect(true);
        }
    }, [history]);

    //Grelha contactos
    const [linhasContactos, setLinhasContactos] = useState([
        {
            id: '',
            codigoContacto: '',
            nome: '',
            apelido: '',
            telemovel: '',
            email: '',
            funcao: null,
            contactoDefeito: false,
            nascimento: null,
        },
    ]);
    const [linhasEnderecos, setLinhasEnderecos] = useState([
        {
            id: '',
            pais: null,
            morada: '',
            codigoPostal: '',
            cidade: '',
            enderecoDefeito: false,
            descricao: '',
            latitude: '',
            longitude: '',
        },
    ]);

    const [funcoes, setFuncoes] = useState([]);
    const [interesses, setInteresses] = useState([]);

    //ProdutosVendidos
    const [produtosVendidos, setProdutosVendidos] = useState([]);
    const [parqueEquipamentos, setParqueEquipamentos] = useState([]);
    const [equipamentosOutrasMarcas, setEquipamentosOutrasMarcas] = useState([
        {
            nSerie: '',
            idLinha: Math.random() * 999999,
            descricao: '',
            marca: '',
            modelo: '',
        },
    ]);
    const [contaCorrente, setContaCorrente] = useState([]);

    const [newProspect, setNewProspect] = useState();

    const [freeze, setFreeze] = useState(false);
    const codCliente = prospect?.codigoCliente;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    useEffect(() => {
        // Se vem de um lead, vai pre-preencher os campos do lead
        if (history.location.state?.lead) {
            var _lead = history.location.state.lead;
            console.log(_lead);
            setNif(_lead.contribuinte);
            setRazaoSocial(_lead.razaoSocial);
            setDivisa(_lead.moeda);
            setResponsavel(_lead.representante);
            setOrigem(_lead.origem);
            setPais(_lead.pais);
            setLingua(_lead.lingua);

            setLinhasEnderecos([
                ..._lead.moradas,
                {
                    id: '',
                    pais: null,
                    morada: '',
                    codigoPostal: '',
                    cidade: '',
                    enderecoDefeito: false,
                    descricao: '',
                    latitude: '',
                    longitude: '',
                },
            ]);
            setLinhasContactos([
                {
                    id: _lead.codigo,
                    nome: _lead.nome,
                    apelido: _lead.apelido,
                    telemovel: _lead.telemovel,
                    telefone: _lead.telefone,
                    cortesia: _lead.cortesia,
                    email: _lead.email,
                    funcao: _lead.funcao,
                    contactoDefeito: true,
                    nascimento: _lead.nascimento,
                },
                {
                    id: '',
                    nome: '',
                    apelido: '',
                    telemovel: '',
                    telefone: '',
                    cortesia: null,
                    email: '',
                    funcao: null,
                    contactoDefeito: false,
                    contactoDefeito: null,
                    nascimento: null,
                },
            ]);
        }
    }, [history]);

    /// quando clicamos no botão para um novo agendamento, redireciona para a pagina de interações com os dados do prospect
    function pushReuniaoVisita() {
        history.push(`Agendamentos`, {prospect: prospect});
    }
    function pushNegocio() {
        history.push(`NegociosEtapas`, {prospect: prospect});
    }
    useEffect(() => {
        if (novaReuniaoVisita && prospect) {
            pushReuniaoVisita();
            setNovaReuniaoVisita(false);
        }
    }, [novaReuniaoVisita, prospect]);

    useEffect(() => {
        if (novoNegocio && prospect) {
            pushNegocio();
            setNovoNegocio(false);
        }
    }, [novoNegocio, prospect]);

    useEffect(() => {
        if (prospect) {
            const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
            const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

            const codCliente = prospect.codigoCliente;
            getFuncoesContactos(lang).then(function (response) {
                if (response.data.success) {
                    setFuncoes(response.data.funcoes);
                }
            });
            // getInfoExtraProspects(codCliente, indexOfFirstItem, indexOfLastItem - 1, lang).then(res => {
            //     if (res.data.success) {
            //         //setProdutosVendidos(res.data.produtosVendidos);
            //         setParqueEquipamentos(res.data.maquinas);
            //         setTotalRegistos(res.data.registos);
            //     }
            // });

            getProspectId(codCliente, lang).then(res => {
                setNewProspect(res.data.cliente);
                setEquipamentosOutrasMarcas(res.data.cliente.equipamentoOutrasMarcas);
            });
        }
    }, [prospect]);

    useEffect(() => {
        if (!!newProspect) {
            setCategoria({
                value: newProspect.categoria,
                label: newProspect.categoriaDescricao,
            });
            setRazaoSocial(newProspect.nomeCliente);
            setPais(newProspect.pais);
            setLingua(newProspect.lingua);
            setDivisa(newProspect.divisa);
            setNif(newProspect.contribuinte);

            setOrigem(newProspect.origem);
            setResponsavel(newProspect.responsavel);

            setActividade(newProspect.actividade);

            setFamilia1(newProspect.familia1);
            setFamilia2(newProspect.familia2);
            setFamilia3(newProspect.familia3);
            setFamilia4(newProspect.familia4);
            setFamilia5(newProspect.familia5);

            setLinhasEnderecos([
                ...newProspect.enderecos,
                {
                    id: '',
                    pais: null,
                    morada: '',
                    codigoPostal: '',
                    cidade: '',
                    enderecoDefeito: false,
                    descricao: '',
                    latitude: '',
                    longitude: '',
                },
            ]);

            setLinhasContactos([
                ...newProspect.contactos,
                {
                    id: '',
                    codigoContacto: '',
                    nome: '',
                    apelido: '',
                    telemovel: '',
                    telefone: '',
                    cortesia: '',
                    email: '',
                    funcao: null,
                    contactoDefeito: false,
                    nascimento: null,
                },
            ]);
        }
    }, [newProspect]);

    useEffect(() => {
        if (pais) {
            getVaidacaoNifPais(lang, pais.value).then(res => {
                if (res.data.success) {
                    setTamanhoNif(parseInt(res.data.num.split('X')[0]));
                }
            });
        }
    }, [pais]);

    useEffect(() => {
        acessos.forEach(element => {
            if (element.funcao == 'GESBPP') {
                if (element.criar) {
                } else {
                    history.push('/Prospects');
                }
            }
        });
    }, [acessos]);

    useEffect(() => {
        getFuncoesContactos(lang).then(function (response) {
            if (response.data.success) {
                setFuncoes(response.data.funcoes);
            }
        });

        getCategorias(lang).then(res => {
            setCategorias(res.data.categorias);
        });

        debugger;
        getContactoInteresses(lang).then(res => {
            setInteresses(res.data.contactoInteresses);
        });

        getOrigens(lang).then(res => {
            setOrigens(res.data.origens);
        });

        getPaises(lang).then(res => {
            setPaises(res.data.paises);
        });

        getLinguas(lang).then(res => {
            setLinguas(res.data.linguas);
        });

        getMoedas(lang).then(res => {
            setMoedas(res.data.moedas);
        });

        getCortesias(lang).then(res => {
            setOptionsCortesia(res.data.cortesias);
        });
        getRepresentantes(lang).then(res => {
            setResponsaveis(res.data.representantes);
        });

        getActividades(lang).then(res => setActividades(res.data.actividades));
    }, []);

    useEffect(() => {
        if (nif && onBlurNif) {
            if (nif.length == tamanhoNif) {
                getValidaNif(nif.toUpperCase()).then(res => {
                    debugger;
                    if (res.data.success) {
                        if (res.data.num && res.data.num !== prospect.codigoCliente) {
                            //Já existe um cliente com o NIF, avisa que já existe
                            toast.error(t('erroNIFDuplicado').format(res.data.num, res.data.nome, res.data.repnam), {
                                position: 'top-right',
                                autoClose: 6000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: 'light',
                            });
                        } else {
                            let countryCode = nif.slice(0, 2);
                            let vatNumber = nif.slice(2, tamanhoNif);

                            getVIES(countryCode.toUpperCase(), vatNumber)
                                .then(res => {
                                    if (res.data.success && res.data.vies.valida) {
                                        setRazaoSocial(res.data.vies.nome);
                                        // setConfirmacaoNifMorada(res.data.vies.morada)
                                    }
                                })
                                .catch(error => {
                                    toast.warn(error, {
                                        position: 'top-right',
                                        autoClose: 6000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: 'light',
                                    });
                                });
                        }
                    }
                });
            }
        }
    }, [nif]);

    function validacaoEndContac() {
        if (linhasEnderecos?.find(e => e.id != '') == null) {
            setValidacaoPais(true);
            setValidacaoCP(true);
            toast.warn(t('insiraEndereco2'), {
                position: 'top-right',
                autoClose: 6000,
            });
            return false;
        }
        if (linhasContactos.find(e => e.id != '') == null) {
            setValidacaoApelido(true);
            setValidacaoNome(true);
            setValidacaoCortesia(true);
            setValidacaoFuncao(true);
            setValidacaoEmail(true);
            setValidacaoTlm(true);
            toast.warn(t('insiraContacto2'), {
                position: 'top-right',
                autoClose: 6000,
            });
            return false;
        }
        return true;
    }

    async function GuardarProspect() {
        var podeGravar = true;
        setLoadingM(true)
        if (!validacaoEndContac()) {
            podeGravar = false;
        }
        if (!categoria) {
            setValidacaoCategoria(true);
            podeGravar = false;
        }
        if (!actividade) {
            setValidacaoActividade(true);
            podeGravar = false;
        }
        if (!responsavel) {
            setValidacaoRep(true);
            podeGravar = false;
        }
        if (!pais) {
            setValidacaoPais(true);
            podeGravar = false;
        }
        if (!lingua) {
            setValidacaoLingua(true);
            podeGravar = false;
        }
        if (!divisa) {
            setValidacaoDivisa(true);
            podeGravar = false;
        }
        if (razaoSocial == '') {
            setValidacaoRS(true);
            podeGravar = false;
        }
        if (!origem) {
            setValidacaoOrigem(true);
            podeGravar = false;
        }

        if (nif == '') {
            setValidacaoNif(true);
            setMsgNif(t('insiraNif'));
            podeGravar = false;
        }

        var res = ValidacaoNif(nif, tamanhoNif, t);
        if (!res.nifValido) {
            setMsgNif(res.msgNif);
            setValidacaoNif(true);
            toast.error(res.msgNif);
            podeGravar = false;
        }

        if (!podeGravar) {
            setLoadingM(false)
            toast.error(t('preenchaCampos'));
            return;
        }

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            postProspect(
                codCliente,
                razaoSocial,
                nif.toUpperCase(),
                categoria?.value,
                linhasEnderecos.filter(m => m.id !== ''),
                pais,
                divisa,
                lingua,
                responsavel,
                origem,
                linhasContactos.filter(x => x.id != ''),
                prospect?.tipoCliente ?? 4,
                actividade,
                equipamentosOutrasMarcas.filter(e => e.nSerie),
                lang,
            )
                .then(res => {
                    let dados = res.data;
                    console.log(dados);
                    if (dados.success) {
                        resolve(dados.message || 'Sucesso!');
                    } else {
                        let mensagem = dados.errorMessages;
                        let resposta = mensagem && mensagem.length > 0 ? mensagem.join(', ') : t('toastErro');
                        reject(resposta);
                    }
                })
                .catch(error => {
                    reject(t('toastErroServidor'));
                });
        });

        toast.promise(
            guardarConclusaoWS,
            {
                success: {
                    render() {
                        setShowForm(false);
                        setEditarProspect(false);
                        setLoadingM(false)
                        return codCliente ? t('prospectAtualizado') : t('prospectCriado');
                    },
                },
                // pending: t('a_guardar'),
                error: {
                    render(data) {
                        // return data.data.length > 0 ? data.data[0] : t('toastErro');
                        if (typeof data.data === 'string') {
                            return data.data;
                        } else if (Array.isArray(data.data) && data.data.length > 0) {
                            return data.data[0];
                        } else {
                            return t('toastErro');
                        }
                        setLoadingM(false)
                    },
                },
            },
            {autoClose: 2000},
        );
        // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
        // por isso tenho de fazer um await
        await Promise.allSettled([guardarConclusaoWS]);
    }

    useEffect(async () => {
        if (guardar) {
            await GuardarProspect();
            setGuardar(false);
        }
    }, [guardar]);

    return (
        <div id="myTabContent">
            {paises.length === 0 && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {loadingM && <LoadingModal />}
            {paises.length != 0 && (
                <form>
                    {openTab === 1 && (
                        <div id="link1">
                            <Detalhes
                                info={{
                                    validacaoCatContacto,
                                    setValidacaoCatContacto,
                                    onBlurNif,
                                    setOnBlurNif,
                                    editarProspect,
                                    prospect,
                                    setPais,
                                    paises,
                                    pais,
                                    setLingua,
                                    linguas,
                                    lingua,
                                    setDivisa,
                                    moedas,
                                    divisa,
                                    setNif,
                                    validacaoNif,
                                    nif,
                                    tamanhoNif,
                                    setValidacaoNif,
                                    setRazaoSocial,
                                    razaoSocial,
                                    validacaoRS,
                                    msgNif,
                                    setCategoria,
                                    categorias,
                                    categoria,
                                    setResponsavel,
                                    responsaveis,
                                    responsavel,
                                    setOrigem,
                                    origens,
                                    origem,
                                    validacaoRS,
                                    validacaoPais,
                                    validacaoLingua,
                                    validacaoDivisa,
                                    validacaoCategoria,
                                    validacaoRep,
                                    validacaoOrigem,
                                    setValidacaoRS,
                                    setValidacaoPais,
                                    setValidacaoLingua,
                                    setValidacaoDivisa,
                                    setValidacaoCategoria,
                                    setValidacaoRep,
                                    setValidacaoOrigem,
                                    setOnChangeForm,

                                    linhasEnderecos,
                                    setLinhasEnderecos,

                                    actividades,
                                    setActividade,
                                    actividade,
                                    setValidacaoActividade,
                                    validacaoActividade,

                                    familia1,
                                    familia2,
                                    familia3,
                                    familia4,
                                    familia5,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 2 && (
                        <div id="link2">
                            <Endereco
                                info={{
                                    prospect,
                                    openTab,
                                    editarProspect,
                                    paises,

                                    linhasEnderecos,
                                    setLinhasEnderecos,

                                    validacaoPais,
                                    setValidacaoPais,
                                    validacaoCP,
                                    setValidacaoCP,

                                    setOnChangeForm,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 3 && (
                        <div id="link3">
                            <Contactos
                                info={{
                                    editarProspect,

                                    setLinhasContactos,
                                    linhasContactos,

                                    funcoes,
                                    interesses,

                                    setValidacaoTlm,
                                    validacaoTlm,
                                    msgTlm,

                                    setValidacaoEmail,
                                    validacaoEmail,
                                    msgEmail,
                                    optionsCortesia,
                                    setValidacaoApelido,
                                    validacaoApelido,
                                    setValidacaoCortesia,
                                    validacaoCortesia,
                                    setValidacaoNome,
                                    validacaoNome,
                                    setValidacaoFuncao,
                                    validacaoFuncao,

                                    setMsgTlm,
                                    setMsgEmail,

                                    setOnChangeForm,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 4 && (
                        <div id="link4">
                            <ProdutosVendidos
                                info={{
                                    prospect,
                                    produtosVendidos,
                                    setProdutosVendidos,
                                    utilizador,
                                    filtroReferencia,
                                    setFiltroReferencia,
                                    filtroDesc,
                                    setFiltroDesc,
                                    filtroQuantidade,
                                    setFiltroQuantidade,
                                    filtroPreco,
                                    setFiltroPreco,
                                    filtroNumEncomenda,
                                    setFiltroNumEncomenda,
                                    formattedDateEnc,
                                    setFormattedDateEnc,
                                    dataPdf,
                                    setDataPdf,
                                    filtroDtEncomenda,
                                    setFiltroDtEncomenda,
                                    filtroPrecoTotal,
                                    setFiltroPrecoTotal,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 5 && (
                        <div id="link5">
                            <ParqueEquipamentos
                                info={{
                                    prospect,
                                    editarProspect,
                                    currentPage,
                                    setCurrentPage,
                                    totalRegistos,
                                    setTotalRegistos,
                                    equipamentosOutrasMarcas,
                                    setEquipamentosOutrasMarcas,
                                    setFiltroEspecificacao,
                                    parqueEquipamentos,
                                    setParqueEquipamentos,
                                    ITEMS_PER_PAGE,
                                    utilizador,
                                    filtroNumEquipamento,
                                    setFiltroNumEquipamento,
                                    filtroNumSerie,
                                    setFiltroNumSerie,
                                    filtroArtigo,
                                    setFiltroArtigo,
                                    filtroMarca,
                                    setFiltroMarca,
                                    filtroNacionalInternacional,
                                    setFiltroNacionalInternacional,
                                    filtroTipo,
                                    setFiltroTipo,
                                    filtroModelo,
                                    setFiltroModelo,
                                    filtroVersao,
                                    setFiltroVersao,
                                    filtroEspecificacao,
                                    marcas,
                                    setMarcas,
                                    nacionaisInternacionais,
                                    setNacionaisInternacionais,
                                    tipos,
                                    setTipos,
                                    modelos,
                                    setModelos,
                                    versoes,
                                    setVersoes,
                                    filtroDescParque,
                                    setFiltroDescParque,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 6 && (
                        <div id="link6">
                            <ContaCorrente
                                info={{
                                    prospect,
                                    contaCorrente,
                                    setContaCorrente,
                                    utilizador,
                                    filtroSociedade,
                                    setFiltroSociedade,
                                    filtroEstab,
                                    setFiltroEstab,
                                    filtroEndereco,
                                    setFiltroEndereco,
                                    filtroDtFatura,
                                    setFiltroDtFatura,
                                    filtroDtVencimento,
                                    setFiltroDtVencimento,
                                    filtroRep,
                                    setFiltroRep,
                                    filtroValor,
                                    setFiltroValor,
                                    filtroValorPendente,
                                    setFiltroValorPendente,
                                    filtroNumDoc,
                                    setFiltroNumDoc,
                                    filtroDivisa,
                                    setFiltroDivisa,
                                    representantes,
                                    setRepresentantes,
                                    estabelecimentos,
                                    setEstabelecimentos,
                                    divisas,
                                    setDivisas,
                                }}
                            />
                        </div>
                    )}

                    {openTab === 7 && (
                        <div id="link7">
                            <HistoricoVisitas
                                info={{
                                    prospect,
                                    filtroCodigo,
                                    setFiltroCodigo,
                                    filtroEstabHistorico,
                                    setFiltroEstabHistorico,
                                    filtroCategoria,
                                    setFiltroCategoria,
                                    filtroDtInicio,
                                    setFiltroDtInicio,
                                    filtroDtFim,
                                    setFiltroDtFim,
                                    filtroRepHistorico,
                                    setFiltroRepHistorico,
                                    categorias,
                                    setCategorias,
                                    setEstabelecimentos,
                                    estabelecimentos,
                                    setRepresentantes,
                                    representantes,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 8 && (
                        <div id="link7">
                            <HistoricoOportunidades
                                info={{
                                    prospect,
                                    //historico de oportunidades
                                    prospect,
                                    //historico de oportunidades
                                    filtroNomeHistorico,
                                    setFiltroNomeHistorico,
                                    filtroEtapa,
                                    setFiltroEtapa,
                                    filtroRepHisOp,
                                    setFiltroRepHisOp,
                                    filtroEmpresa,
                                    setFiltroEmpresa,
                                    filtroDt,
                                    setFiltroDt,
                                    filtroValorHistorico,
                                    setFiltroValorHistorico,
                                    etapasHistoricoOp,
                                    setEtapasHistoricoOp,
                                    representantesHistoricoOp,
                                    setRepresentantesHistoricoOp,
                                }}
                            />
                        </div>
                    )}
                    {openTab === 9 && (
                        <div id="link7">
                            <HistoricoPropostas
                                info={{
                                    prospect,
                                    filtroId,
                                    setFiltroId,
                                    filtroTipoProposta,
                                    setFiltroTipoProposta,
                                    filtroDtProposta,
                                    setFiltroDtProposta,
                                    filtroCliente,
                                    setFiltroCliente,
                                    filtroEstado,
                                    setFiltroEstado,
                                    filtroLinhas,
                                    setFiltroLinhas,
                                    formattedDate,
                                    setFormattedDate,
                                    ids,
                                    setIds,
                                    tiposProposta,
                                    setTiposProposta,
                                    estados,
                                    setEstados,
                                }}
                            />
                        </div>
                    )}
                </form>
            )}
            <ToastContainer />
            {showExitModal && (
                <ExitForm
                    cancelar={() => setShowExitModal(false)}
                    back={() => {
                        setShowForm(false);
                        setShowExitModal(false);
                        setEditarProspect(false);
                    }}
                />
            )}
        </div>
    );
}

export default ProspectsForm;
